export default "__VITE_ASSET__44c0ab9b__"